import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f25ff6e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("记录")
const _hoisted_8 = { style: {"margin-top":"20px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "商品信息", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","margin-top":"20px"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商品图片"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "标价"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "价格"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "销量"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "库存"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "当前价"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "团购价"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "备注")
], -1))
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "拼团商品" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'name' && record.goods!== null )
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record.goods.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'image' && record.goods!== null)
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 1,
                  src: record.goods.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'market_price' && record.goods!== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.goods.market_price), 1))
              : _createCommentVNode("", true),
            (column.key === 'max_price' && record.goods!== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.goods.max_price), 1))
              : _createCommentVNode("", true),
            (column.key === 'min_price' && record.goods!== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.goods.min_price), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.getDetail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.getRecord(record)),
                    style: {"margin-left":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      title: "拼团详情",
      footer: null,
      width: "60%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          title: "拼团信息",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.goods.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "商品图片" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  src: _ctx.detailData.goods.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "拼团人数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.people_num), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "销量" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.sales_volume), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "标价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.goods.market_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "最高价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.goods.max_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "最低价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.goods.min_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "库存" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.goods.stock), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "团购最高价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.team_max_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "团购最低价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.team_min_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "活动开始时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.activity_start_time), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "活动结束时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.activity_end_time), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.teamGoods, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {"display":"flex","margin-bottom":"100px"}
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_image, {
                  src: item.image,
                  style: {"height":"40px"}
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.market_price), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.price), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(item.sales_volume), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.stock), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.active_price), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(item.team_price), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(item.spec_value_str), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}